module.exports = __webpack_public_path__ + "img/add account.3be80ff2.svg";